import React from 'react';

import { SVGPropsType } from 'src/types';

function More(props: SVGPropsType) {
    const { fill, stroke, onClick, style, className } = props;

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path d="M4.8843 5H15.1158" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M9.74541 10H15.2547" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M4.8843 15H15.1158" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
            <path
                d="M7.15827 9.74569C7.34627 9.86319 7.34627 10.137 7.15827 10.2545L4.69097 11.7965C4.49116 11.9214 4.23197 11.7778 4.23197 11.5421L4.23197 8.45803C4.23197 8.2224 4.49116 8.07874 4.69097 8.20363L7.15827 9.74569Z"
                fill={fill}
            />
        </svg>
    );
}

export default More;
